import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import UserDetail from '@app/views/User/Detail';
import { memo } from 'react';

export default memo(
  withIfUser(UserDetail)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
